<scw-mat-select
  [data]="dropdownList"
  [(inputModel)]="selectedItems"
  [isLoading]="isLoading$"
  [singleSelection]="defaultSettings.singleSelection"
  [text]="defaultSettings.text"
  [enableCheckAll]="defaultSettings.enableCheckAll"
  [limitSelection]="defaultSettings.limitSelection"
  [selectAllText]="defaultSettings.selectAllText"
  [unSelectAllText]="defaultSettings.unSelectAllText"
  [filterSelectAllText]="defaultSettings.filterSelectAllText"
  [filterUnSelectAllText]="defaultSettings.filterUnSelectAllText"
  [enableSearchFilter]="defaultSettings.enableSearchFilter"
  [searchBy]="defaultSettings.searchBy"
  [groupBy]="defaultSettings.groupBy"
  [maxHeight]="defaultSettings.maxHeight"
  [badgeShowLimit]="defaultSettings.badgeShowLimit"
  [classes]="defaultSettings.classes"
  [disabled]="isLoading$"
  [searchPlaceholderText]="defaultSettings.searchPlaceholderText"
  [showCheckbox]="defaultSettings.showCheckbox"
  [noDataLabel]="defaultSettings.noDataLabel"
  [searchAutofocus]="defaultSettings.searchAutofocus"
  [lazyLoading]="defaultSettings.lazyLoading"
  [labelKey]="defaultSettings.labelKey"
  [primaryKey]="defaultSettings.primaryKey"
  [position]="defaultSettings.position"
  [autoPosition]="defaultSettings.autoPosition"
  [enableFilterSelectAll]="defaultSettings.enableFilterSelectAll"
  [selectGroup]="defaultSettings.selectGroup"
  [addNewItemOnFilter]="defaultSettings.addNewItemOnFilter"
  [addNewButtonText]="defaultSettings.addNewButtonText"
  [escapeToClose]="defaultSettings.escapeToClose"
  [clearAll]="defaultSettings.clearAll"
  [noPadding]="true"
  [belongsToFilterCardComponent]="true"
  [searchBehavior]="defaultSettings.enableServerSideSearch && defaultSettings.enableSearchFilter ? 'delayed': 'live'"
  (onSelect)="onItemSelect()"
  (onDeSelect)="onItemDeselect()"
  (onSelectAll)="onSelectAll()"
  (onDeSelectAll)="onDeSelectAll()"
  (onGroupSelect)="onGroupSelect()"
  (onGroupDeSelect)="onGroupDeSelect()"
  (onSearch)="onSearch($event)"
  (onScrollToEnd)="fetchMore($event)"
></scw-mat-select>
